import { useState } from 'react';
import { useSelector } from 'react-redux';
import { StartNodeData } from 'modules/workflows/types';
import { getIsNodeEditorReadOnly } from 'modules/workflows/ducks';
import { StartNodeContext } from './StartNodeEditorContext';
import { StartNodeEditorProps } from '../StartNodeEditor.types';

export const StartNodeContextProvider = ({ children, ...rest }: StartNodeEditorProps) => {
  const { nodeData: initialNodeData, workflowData: initialWorkflowData } = rest;

  const isReadOnly = useSelector(getIsNodeEditorReadOnly);

  const [nodeData, setNodeData] = useState(initialNodeData || {});
  const [workflowData, setWorkflowData] = useState(initialWorkflowData || {});
  const [hasLinkedJourneys, setHasLinkedJourneys] = useState(false);

  const updateInternalNodeData = (updates: Partial<StartNodeData>) => {
    setNodeData({
      ...nodeData,
      // reset all resource values if trigger changes
      ...(updates.nodeClass
        ? {
            emailListId: undefined,
            emailCampaignId: undefined,
            channelId: undefined,
            field: undefined,
            eventName: undefined,
          }
        : {}),
      // reset search combo if trigger/event changes
      ...(updates.nodeClass || updates.eventName ? { searchCombo: undefined } : {}),
      // use initial search combo if user switches back to initial entry source
      ...(updates.nodeClass === initialNodeData.nodeClass && {
        searchCombo: initialNodeData.searchCombo,
      }),
      ...updates,
    });
  };

  return (
    <StartNodeContext.Provider
      value={{
        hasLinkedJourneys,
        isReadOnly,
        initialNodeData,
        nodeData,
        setHasLinkedJourneys,
        setNodeData: updateInternalNodeData,
        setWorkflowData,
        workflowData,
      }}
    >
      {children}
    </StartNodeContext.Provider>
  );
};
